module.exports = __webpack_public_path__ + "assets/img/navigation_star.svg";